enum TeamLockTypes {
  Event = 'event',
  Campaign = 'campaign',
  Charity = 'charity',
}

export default TeamLockTypes;
